<div
  (smartPreviewOpen)="smartPreviewOpen.next($event)"
  (smartPreviewVisited)="smartPreviewVisited.next($event)"
  [routerLink]="['comments']"
  [smartPreviewDisabled]="(unseenThreadsCount$ | async) === 0"
  libSmartPreview="unseen-comments"
>
  <div
    [matBadgeHidden]="(unseenThreadsCount$ | async) === 0"
    [matBadge]="unseenThreadsCount$ | async"
    class="buttonContainer"
  >
    <lib-button icon-only>
      <mat-icon>comment</mat-icon>
    </lib-button>
  </div>
  Komentarze
</div>
